const EvaluationCriteriaTabs = () =>
  import(
    "@/features/dep/evaluation_criteria/home/presentation/views/EvaluationCriteriaTabs.vue"
  );
const DepInstitutionalCriteriaSection = () =>
  import(
    "@/components/evaluation/institutionalCriteria/DepInstitutionalCriteriaSection.vue"
  );
const DepEvaluationModelsSection = () =>
  import(
    "@/components/evaluation/evaluationModels/DepEvaluationModelsSection.vue"
  );

export const evaluationCriteriaRoutes = [
  {
    path: "/evaluation/localcriteria-config",
    component: EvaluationCriteriaTabs,
    children: [
      {
        name: "institutional-criteria",
        path: "",
        component: DepInstitutionalCriteriaSection,
      },
      {
        name: "evaluation-models",
        path: "evaluationmodels",
        component: DepEvaluationModelsSection,
      },
    ],
  },
];
